/** @format */
import { createAction, createReducer } from '@reduxjs/toolkit';

export const initialState = {
  tableData: {
    label: [],
    body: [],
    colNames: [],
    totalRows: '',
    types: [],
    formatMask: []
  },
  cacheTableData: {},

  filters: {
    orderFields: [],
    orderDirects: []
  },
  data: {
    dataDaUp: null,
    dataAUp: null
  },
  textFilters: {
    filterFields: [
      /* {
        textFields: '',
        textValue: '',
        i: 0
      } */
    ]
  },
  funzione: {
    id: null
  }
};

export const updateData = createAction('updateData');
export const updateFunzione = createAction('updateFunzione');
export const updateTableData = createAction('updateTableData');
export const updateFilters = createAction('updateFilters');
export const updateTextFilters = createAction('updateTextFilters');

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(updateData, (state, action) => {
      state.data = { ...state.data, ...action.payload };
    })
    .addCase(updateTableData, (state, action) => {
      state.tableData = { ...state.tableData, ...action.payload };
    })
    .addCase(updateFilters, (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    })
    .addCase(updateTextFilters, (state, action) => {
      state.textFilters = { ...state.textFilters, ...action.payload };
    })
    .addCase(updateFunzione, (state, action) => {
      state.funzione = { ...state.funzione, ...action.payload };
    });
});

export default reducer;
